"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.formatTransaction = exports.toTransactionRaw = exports.fromTransactionRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
var common_1 = require("../../transaction/common");
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var utils_1 = require("./utils");
var logic_1 = require("./logic");
var fromTransactionRaw = function (tr) {
    var common = (0, common_1.fromTransactionCommonRaw)(tr);
    var family = tr.family, model = tr.model, feeCalculator = tr.feeCalculator;
    return __assign(__assign({}, common), { family: family, model: JSON.parse(model), feeCalculator: feeCalculator });
};
exports.fromTransactionRaw = fromTransactionRaw;
var toTransactionRaw = function (t) {
    var common = (0, common_1.toTransactionCommonRaw)(t);
    var family = t.family, model = t.model, feeCalculator = t.feeCalculator;
    return __assign(__assign({}, common), { family: family, model: JSON.stringify(model), feeCalculator: feeCalculator });
};
exports.toTransactionRaw = toTransactionRaw;
var lamportsToSOL = function (account, amount) {
    return (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), new bignumber_js_1.BigNumber(amount), {
        showCode: true,
        disableRounding: true
    });
};
var formatTransaction = function (tx, mainAccount) {
    if (tx.model.commandDescriptor === undefined) {
        throw new Error("can not format unprepared transaction");
    }
    var commandDescriptor = tx.model.commandDescriptor;
    switch (commandDescriptor.status) {
        case "valid":
            return formatCommand(mainAccount, tx, commandDescriptor.command);
        case "invalid":
            throw new Error("can not format invalid transaction");
        default:
            return (0, utils_1.assertUnreachable)(commandDescriptor);
    }
};
exports.formatTransaction = formatTransaction;
function formatCommand(mainAccount, tx, command) {
    switch (command.kind) {
        case "transfer":
            return formatTransfer(mainAccount, tx, command);
        case "token.transfer":
            return formatTokenTransfer(mainAccount, tx, command);
        case "token.createATA":
            return formatCreateATA(mainAccount, tx, command);
        default:
            return (0, utils_1.assertUnreachable)(command);
    }
}
function formatTransfer(mainAccount, tx, command) {
    var amount = lamportsToSOL(mainAccount, command.amount);
    var str = [
        "  SEND: ".concat(amount).concat(tx.useAllAmount ? " (ALL)" : ""),
        "  TO: ".concat(command.recipient),
        command.memo ? "  MEMO: ".concat(command.memo) : "",
    ]
        .filter(Boolean)
        .join("\n");
    return "\n" + str;
}
function formatTokenTransfer(mainAccount, tx, command) {
    if (!tx.subAccountId) {
        throw new Error("expected subaccountId on transaction");
    }
    var subAccount = (0, account_1.findSubAccountById)(mainAccount, tx.subAccountId);
    if (!subAccount || subAccount.type !== "TokenAccount") {
        throw new Error("token subaccount expected");
    }
    var amount = (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(subAccount), new bignumber_js_1.BigNumber(command.amount), {
        showCode: true,
        disableRounding: true
    });
    var recipient = command.recipientDescriptor.walletAddress;
    var str = [
        "  SEND: ".concat(amount).concat(tx.useAllAmount ? " (ALL)" : ""),
        "  TO: ".concat(recipient),
        command.memo ? "  MEMO: ".concat(command.memo) : "",
    ]
        .filter(Boolean)
        .join("\n");
    return "\n" + str;
}
function formatCreateATA(mainAccount, tx, command) {
    var token = (0, currencies_1.getTokenById)((0, logic_1.toTokenId)(command.mint));
    var str = ["  OPT IN TOKEN: ".concat(token.ticker)].filter(Boolean).join("\n");
    return "\n" + str;
}
exports["default"] = {
    formatTransaction: exports.formatTransaction,
    fromTransactionRaw: exports.fromTransactionRaw,
    toTransactionRaw: exports.toTransactionRaw
};
//# sourceMappingURL=transaction.js.map